import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { studentRequests } from "api/studentApi";
import {
  CreateButton,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  ListActions,
  ReferenceField,
  ShowButton,
  SimpleList,
  TextField,
  useStore,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { Box, Typography, Paper, useMediaQuery } from "@mui/material";
import CustomFilter from "features/CustomFilter";
import useSemesterFilter from "features/filters/useSemesterFilter";
import { WeekDaysChoices } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const STORE_KEY = "sportSchedule.filters";

const ListSportSchedule = () => {
  const [filters, setFilters] = useStore(STORE_KEY, null);
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const semester = useSemesterFilter({ filters, withLanguage: true, withStudyType: true });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };

  return (
    <>
      <CustomFilter
        title="Избери разписание"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={semester.fields}
        buttonLabel="Покажи"
        buttonDisabled={!semester.isComplete}
        buttonOnClick={() => handleSearch(semester.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 3 }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за разписание за спорт или създай ново.
            </Typography>
            <CreateButton />
          </Box>
        </Paper>
      ) : (
        <List
          title="Разписание спорт"
          filter={filters}
          exporter={false}
          actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageSportActivities)} />}
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={record => (
                <div>
                  <MobileListRow fields={[{ label: "Спорт", value: record?.sportNameBg }]} />
                  <MobileListRow
                    fields={[
                      {
                        label: "Семестър",
                        value: (
                          <ReferenceField
                            source="academicSessionId"
                            reference={studentRequests.getAcademicSessionsSelect()}
                          >
                            <TextField source="sessionTypeText" />
                          </ReferenceField>
                        ),
                      },
                    ]}
                  />
                </div>
              )}
              secondaryText={record => (
                <div>
                  <MobileListRow
                    fields={[
                      { label: "Ден", value: WeekDaysChoices.find(d => d.id === record.weekDay)?.name },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Час",
                        value: `${record.startTime.slice(0, 5)} - ${record.endTime.slice(0, 5)}`,
                      },
                    ]}
                  />
                </div>
              )}
              tertiaryText={() => (
                <>
                  <SecuredComponent permission={permissions.canManageSportActivities}>
                    <EditButton label="" />
                  </SecuredComponent>
                  <SecuredComponent permission={permissions.canPreviewSportActivities}>
                    <ShowButton label="" />
                  </SecuredComponent>
                </>
              )}
            />
          ) : (
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
            >
              <TextField
                source="sportNameBg"
                label="Спорт"
              />
              <ReferenceField
                source="academicSessionId"
                label="Семестър"
                reference={studentRequests.getAcademicSessionsSelect()}
              >
                <TextField source="sessionTypeText" />
              </ReferenceField>

              <FunctionField
                label="Ден"
                render={record => WeekDaysChoices.find(d => d.id === record.weekDay)?.name}
              />
              <FunctionField
                label="Час"
                render={record => `${record.startTime.slice(0, 5)} - ${record.endTime.slice(0, 5)}`}
              />
              <SecuredComponent permission={permissions.canManageSportActivities}>
                <EditButton />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewSportActivities}>
                <ShowButton />
              </SecuredComponent>
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListSportSchedule;
